export const ADMIN_HOME = '/admin';
export const ADMIN_POOLS_TRANS_LIST = `${process.env.REACT_APP_POOL_HOST}/:type/transactions`;
export const ADMIN_LOANS_TRANS_LIST = `${process.env.REACT_APP_LOAN_HOST}/:type/transactions`;
export const ADMIN_TRANS_LIST = '/:type/transactions';
export const ADMIN_TRANS_DEFAULT = '/:product(securitization|ptc|ncd|cp|ps|tl|da)/:transId/tools/pool-selection';
export const ADMIN_TRANS_OLD = '/admin/:product(securitization|ptc|ncd|cp|ps|tl|da)/:transId/:any(tools|details-view)/:x';

export const ADMIN_TRANS_NCD = '/ncd/:transId';
export const ADMIN_TRANS_NCD_DETAILS_VIEW = '/ncd/:transId/details-view';
export const ADMIN_TRANS_NCD_ATTACHMENTS = '/ncd/:transId/attachments';
export const ADMIN_TRANS_NCD_ADMIN_VIEW = '/ncd/:transId/tools';
export const ADMIN_TRANS_NCD_DETAILS = '/ncd/:transId/tools/deal-details';
export const ADMIN_TRANS_NCD_COUNTERPARTY = '/ncd/:transId/tools/counterparties';
export const ADMIN_TRANS_NCD_DOCUMENTS = '/ncd/:transId/tools/documents';
export const ADMIN_TRANS_NCD_STAMPDUTY = '/ncd/:transId/tools/stamp-duty';
export const ADMIN_TRANS_NCD_BIDS = '/ncd/:transId/tools/bids';
export const ADMIN_TRANS_NCD_RELEASE = '/ncd/:transId/tools/release';
export const ADMIN_TRANS_NCD_FINALISE = '/ncd/:transId/tools/finalise';
export const ADMIN_TRANS_NCD_ACTORS = '/ncd/:transId/tools/counterparties';
export const ADMIN_TRANS_NCD_TASKS = '/ncd/:transId/tools/task-status';
export const ADMIN_TRANS_NCD_TASKS_REPORTER = '/ncd/:transId/tools/task-report';
export const ADMIN_TRANS_NCD_INVESTOR_INTERESTS = '/ncd/:transId/tools/interested-investors';
export const ADMIN_TRANS_NCD_DOCUMENTS_VIEW = '/ncd/:transId/documents-view';

export const ADMIN_TRANS_CP = '/cp/:transId';
export const ADMIN_TRANS_CP_DETAILS_VIEW = '/cp/:transId/details-view';
export const ADMIN_TRANS_CP_ATTACHMENTS = '/cp/:transId/attachments';
export const ADMIN_TRANS_CP_ADMIN_VIEW = '/cp/:transId/tools';
export const ADMIN_TRANS_CP_DETAILS = '/cp/:transId/tools/deal-details';
export const ADMIN_TRANS_CP_DOCUMENTS = '/cp/:transId/tools/documents';
export const ADMIN_TRANS_CP_BIDS = '/cp/:transId/tools/bids';
export const ADMIN_TRANS_CP_RELEASE = '/cp/:transId/tools/release';
export const ADMIN_TRANS_CP_FINALISE = '/cp/:transId/tools/finalise';
export const ADMIN_TRANS_CP_ACTORS = '/cp/:transId/tools/counterparties';
export const ADMIN_TRANS_CP_TASKS = '/cp/:transId/tools/task-status';
export const ADMIN_TRANS_CP_TASKS_REPORTER = '/cp/:transId/tools/task-report';
export const ADMIN_TRANS_CP_INVESTOR_INTERESTS = '/cp/:transId/tools/interested-investors';
export const ADMIN_TRANS_CP_DOCUMENTS_VIEW = '/cp/:transId/documents-view';

export const ADMIN_DOCUMENT_COLLABORATOR_CP = '/cp/:transId/documents/:docId/editor';
export const ADMIN_DOCUMENT_COLLABORATOR_NCD = '/ncd/:transId/documents/:docId/editor';

export const ADMIN_REPORTS_LIST = '/reports';
export const ADMIN_REPORTS_DETAILS = '/reports/:reportType/details';
export const ADMIN_MANAGE_ROLE = '/entities/:entityId/:actor/manage-roles';
